import { KommerSnart } from '../../../components/ui/KommerSnart'

export function ModulerTab() {
  return (
    <KommerSnart
      description="Moduler og integrationer: Criipto (digital underskrift), e-conomic (bogføring), Betalingsservice (PBS)."
    />
  )
}
